import { gql } from 'graphql-request'

export namespace ScheduledCommunicationQueries {
  export const QUERY_KEY = 'getScheduledCommunications'

  export function getScheduledCommunications() {
    return gql`
      query getScheduledCommunications($filter: ScheduledCommunicationFilter) {
        scheduledCommunications(filter: $filter) {
          ...ScheduledCommunicationSummary
          reservation {
            flightxInProgress
            lexit
            standby
            professionalHousing
            fromBarsala
            member {
              id
              fullName
            }
            home {
              property {
                market {
                  timezone
                }
              }
            }
          }
        }
      }
      ${ScheduledCommunicationQueries.SCHEDULED_COMMUNICATION_SUMMARY}
    `
  }

  export const SCHEDULED_COMMUNICATION_SUMMARY = gql`
    fragment ScheduledCommunicationSummary on ScheduledCommunication {
      id
      destination
      content
      reservationId
      scheduledDatetime
      status
    }
  `
}
